/* PDP v2 pilot (2026-10-22, Guido): tasting chapter scroll, Ask button in the sticky bar, product-aware Ask drawer.
   Loaded only by sections/pw-pdp-tasting.liquid (templates/product.pdp-v2.json). */
(function () {
  if (window.pwPdpV2) return;
  window.pwPdpV2 = true;
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var clamp = function (v) { return v < 0 ? 0 : v > 1 ? 1 : v; };

  function tasting(root) {
    var notes = $$('.pdt-note', root), chips = $$('.pdt__chips li', root), stage = root.querySelector('.pdt__stage');
    var sentence = root.querySelector('[data-pdt-sentence]');
    var n = notes.length;
    // Highlight each note's label in the sentence when it appears there (case-insensitive).
    var marks = [];
    if (sentence) {
      var html = sentence.textContent.replace(/[&<>]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;' }[c]; });
      chips.forEach(function (c) {
        var label = c.dataset.label;
        if (!label) return;
        var re = new RegExp('\\b(' + label.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')\\b', 'i');
        if (re.test(html)) html = html.replace(re, '<mark data-i="' + c.dataset.i + '">$1</mark>');
      });
      sentence.innerHTML = html;
      marks = $$('mark', sentence);
    }
    // Same size for every word: the size that fits the longest one in the frame.
    var words = notes.map(function (it) { return it.querySelector('.pdt-note__word'); }).filter(Boolean);
    var chars = notes.map(function (it) {
      var w = it.querySelector('.pdt-note__word');
      if (!w) return $$('.pdt-drinks__h, .pdt-drinks__row', it);
      w.innerHTML = w.textContent.split('').map(function (c) { return c === ' ' ? ' ' : '<span class="ch">' + c + '</span>'; }).join('');
      return $$('.ch', w);
    });
    function size() {
      if (!words.length) return;
      var pad = innerWidth < 1024 ? 40 : 80, cap = innerWidth < 1024 ? 120 : 200;
      // Pack screens (wine type + bottle): short words like RED would grow into the bottle; keep them near the Starter Pack size
      if (stage.closest('.pdt--pack') && innerWidth >= 1024) cap = 110;
      words.forEach(function (w) { w.style.fontSize = '100px'; });
      var px = Math.min.apply(null, [cap].concat(words.map(function (w) { return (stage.clientWidth - pad) * 0.98 / w.scrollWidth * 100; })));
      words.forEach(function (w) { w.style.fontSize = px + 'px'; });
    }
    size();
    addEventListener('resize', size);
    if (document.fonts) document.fonts.ready.then(size);

    // Every animated piece gets its stagger index (--k); the CSS transitions do the motion.
    chars.forEach(function (list) { list.forEach(function (el, k) { el.style.setProperty('--k', k); }); });
    // Fit How it drinks inside the frame: step the text down until nothing is cut.
    var drinks = root.querySelector('.pdt-note--drinks');
    function fitDrinks() {
      if (!drinks) return;
      drinks.style.removeProperty('--fit');
      for (var f = 1; f > 0.6 && drinks.scrollHeight > drinks.clientHeight + 1; f -= 0.05) drinks.style.setProperty('--fit', f.toFixed(2));
    }
    fitDrinks();
    addEventListener('resize', fitDrinks);
    if (document.fonts) document.fonts.ready.then(fitDrinks);

    var cur = -1;
    function mark(i) {
      if (i === cur) return;
      cur = i;
      notes.forEach(function (it, j) { it.classList.toggle('is-on', j === i); it.classList.toggle('is-past', j < i); });
      marks.forEach(function (m) { m.classList.toggle('is-on', +m.dataset.i === i); });
      chips.forEach(function (c) { c.classList.toggle('is-on', +c.dataset.i === i); });
      root.style.backgroundColor = notes[i].style.getPropertyValue('--tint');
    }
    if (reduce || n < 2) { root.classList.add('is-ready'); if (n === 1) mark(0); return; }

    // Scroll picks the screen; each change plays a short timed transition, so speed of the swipe never shows.
    // Desktop pins .pdt__pin over the whole section. Under 1024px only the stage sticks, after the sentence
    // has scrolled by, and its travel is the spacer after it (.pdt__inner::after).
    var inner = root.querySelector('.pdt__inner'), side = root.querySelector('.pdt__side'), raf = 0;
    function measure() {
      raf = 0;
      var r = root.getBoundingClientRect(), cs = getComputedStyle(stage), past, span;
      if (cs.position === 'sticky') {
        var nat = side.getBoundingClientRect().bottom - r.top + parseFloat(cs.marginTop);
        past = parseFloat(cs.top) - r.top - nat;
        span = parseFloat(getComputedStyle(inner, '::after').height) || 0;
      } else {
        past = -r.top;
        span = root.offsetHeight - innerHeight;
      }
      var t = span > 0 ? clamp(past / span) * n : 0;
      mark(Math.min(n - 1, Math.floor(t)));
    }
    function onScroll() { if (!raf) raf = requestAnimationFrame(measure); }
    measure();
    requestAnimationFrame(function () { root.classList.add('is-ready'); });
    addEventListener('scroll', onScroll, { passive: true });
    addEventListener('resize', onScroll);
  }

  // Sticky bar: an Ask button before Add to cart. It opens the Ask drawer about this wine.
  function stickyAsk() {
    var card = document.querySelector('.pw-ask--v2');
    var bar = document.querySelector('sticky-add-to-cart .sticky-add-to-cart__button');
    var dialog = document.querySelector('[data-pw-ask-dialog]');
    if (!card || !bar || !dialog) return;
    var panel = dialog.querySelector('[data-pw-ask]');
    // Make the site-wide drawer answer about this product on this page: same handle, title and suggestions as the card.
    panel.dataset.handle = card.dataset.handle;
    var title = dialog.querySelector('.pw-ask__title');
    if (title) title.textContent = 'Ask about this wine';
    var chips = dialog.querySelector('[data-pw-ask-chips]'), cardChips = card.querySelector('[data-pw-ask-chips]');
    if (chips && cardChips) chips.innerHTML = cardChips.innerHTML;
    var input = dialog.querySelector('.pw-ask__input');
    if (input) input.placeholder = 'Ask anything about this wine';
    // Same wrapper and button classes as Add to cart (white = the theme's outline button), so size, font, edge and lip match.
    var wrap = document.createElement('div');
    wrap.className = 'sticky-add-to-cart__button pw-sticky-ask-wrap';
    wrap.innerHTML = '<button type="button" class="button button--outline button--regular pw-sticky-ask"><span class="button__text">Ask</span></button>';
    wrap.firstChild.addEventListener('click', function () { if (window.pwAsk && window.pwAsk.open) window.pwAsk.open(); });
    bar.parentNode.insertBefore(wrap, bar);
  }

  function boot() {
    $$('[data-pdt]').forEach(tasting);
    stickyAsk();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
